export type Testimonial = {
  name: string,
  role: string,
  message: string,
  profileUrl: `/testimonials${string}.${"jpg" | "png"}`
}

export const testimonials: Array<Testimonial> = [
  {
    name: "امیر فراهانی",
    role: "دانش آموز",
    message: "شاهکاره همه سوالای درسی و علمی و محاسبات رو بخوبی انجام میده.(امتحانام هم باهاش میدم😂)",
    profileUrl: "/testimonials/profiles/1.png"
  },
  {
    name: "یاشا فتاحی",
    role: "دانش آموز",
    message: "فیگAI از بین سرویس های مشابه ای که تست کردم بهترین تجربه رو برام داشت. از همه لحاظ؛ قیمت، ثبات و از همه مهم تر چیزی که بیشتر من رو جذب کرد سرعت پاسخگویی پشتیبانیشون بود.",
    profileUrl: "/testimonials/profiles/5.png"
  },
  {
    name: "محمدرضا سجادی",
    role: "برنامه نویس",
    message: "درحال یادگیریه برنامه نویسی هستم. هوش مصنوعی فیگ ای آی در طول یادگیریه من کمک های زیادی در زمینه های مختلف به من کرده.",
    profileUrl: "/testimonials/profiles/6.png"
  },
  {
    name: "آراد",
    role: "مدیریت آموزشگاه نخستین",
    message: "فیگ ای آی بهم کمک کرد راحت‌تر و سریع‌تر از همیشه کد بزنم هر وقتیم به مشکل میخوردم از پشتیبانیه حرفه ای سوال می‌پرسیدم با یه اشتراک ارزون تونستم کل پروژه هامو خیلی سریع پیش ببرم.",
    profileUrl: "/testimonials/profiles/2.png"
  },
  {
    name: "کیارش اکبری",
    role: "برنامه نویس فرانت اند",
    message: "فیگ ای آی واقعا سرویس زیبا و کاربردی ای هست برای سرچ به اینترنت بین الملل وصل هست و سرعتش هم بالاست. درکل پیشنهادش میکنم.",
    profileUrl: "/testimonials/profiles/7.png"
  },
  {
    name: "ارمیا مقدمی",
    role: "دانشجوی دانشگاه صنعتی شریف",
    profileUrl: "/testimonials/profiles/3.png",
    message: "یکی از بهترین تجارب تهیه سرویس ai بود که داشتم، از تنوع مدل های زبانی بگیر تا پشتیبانی حرفه ای شون. همچنین خوشحالم از محصولی استفاده میکنم که بدست نیرو های جوان و با استعداد ساخته شده."
  },
  {
    name: "محمد",
    role: "برنامه نویس",
    profileUrl: "/testimonials/profiles/4.png",
    message: "تو زمان قطعی نت تنها جایی که واقعا از سرویس های خارجی استفاده میکرد همین رفقای فیگ بودن. کارم رو راه انداختن. دمشون گرم."
  },
  {
    name: "زهرا خادمی",
    role: "معلم",
    profileUrl: "/testimonials/profiles/f-3.png",
    message: " از هوش مصنوعی فیگ ای آی استفاده می کنم و خیلی راضی هستم. هم سرعت خوبی داره و هم اطلاعاتش بروزه، به شاگردام هم توصیه کردم استفاده کنند و خیلی راضی بودند."
  },
  {
    name: "رومینا عارف کیا",
    role: "برنامه نویس",
    profileUrl: "/testimonials/profiles/f-1.png",
    message: "به عنوان یه برنامه نویس فیگ ای ای خیلی کارمو راه انداخت و سرعتمو چند برابر کرد. هم برای ایده گرفتن خوبه و هم هر جا گیر کردم بهترین راه رو بهم داد."
  },
  {
    name: "محمد",
    role: "برنامه نویس",
    profileUrl: "/testimonials/profiles/6.png",
    message: "آقا جدا عالی بود خدماتتون تو گروه های مختلف هم گفتم."
  },
  {
    name: "پرنیان طباطبائی",
    role: "پشتیبان نرم افزار",
    profileUrl: "/testimonials/profiles/f-2.png",
    message: "برای کارهای تحقیقاتی و پایان نامه از فیگ ای آی استفاده میکنم، واقعا سریع هستش و جواب هایی که بهم میده خیلی خوب هستش و متنی که تولید میکنه دقیقا متناسب با نیازمه و منظورم رو خوب میفهمه مخصوصا وقتی مدل ها رو عوض میکنم جواب ها بهتر هم میشه پشتیبانی بسیار عالی و سریع هستش و تا حالا به مشکلی برنخوردم."
  },
  {
    name: "حامد",
    role: "دانشجو",
    profileUrl: "/testimonials/profiles/7.png",
    message: "فیگ ای آی یکی از هوش مصنوعی های خیلی خوب ایرانیه که همه مدل های هوش مصنوعی خوب را داره."
  }
]